import React from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "./pages/Login/Login.jsx";
import Header from "./common-components/header/Header.jsx";
import { Spinner, Offcanvas } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Page Components
import {
  Registration,
  ForgotPassword,
  ChangePassword,
  CodeConversion,
  CodeOverview,
  CodeAudit,
  DatabaseConversion,
  PremiumFeatures,
  LiveTesting,
  CodeSpecification,
  BusinessRequirements,
  CodeDocumentation,
  DataGeneration,
  UnitTest,
  CodeImpactAnalysis,
  CodeRefactoring,
  VersionBasedConversion,
  TargetArchitectureBasedConversion,
  ETLMapping,
  Feedback,
  CaseScenarios,
  ArchitectureConversion,
  SecurityValidator,
  UserList,
  PricingDetails,
  FAQPage,
  Profile,
  ConversionHistory,
  ConversionDetails,
  VersionUpgrade,
} from "./pages/index.js";

const AppRoute = () => {
  const location = useLocation();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const apiCount = useSelector((state) => state.common.apiCount);
  const loadingMessage = useSelector((state) => state.common.loadingMessage);

  // Route configuration
  const routes = [
    { path: "/login", element: <Login />, isPublic: true },
    { path: "/register", element: <Registration />, isPublic: true },
    { path: "/forgotPassword", element: <ForgotPassword />, isPublic: true },
    { path: "/", element: <Navigate to={isLoggedIn ? "/live-testing" : "/login"} /> },
    { path: "/settings/change-password", element: <ChangePassword /> },
    { path: "/code-conversion", element: <CodeConversion /> },
    { path: "/version-upgrade", element: <VersionUpgrade /> },
    { path: "/database-conversion", element: <DatabaseConversion /> },
    { path: "/premium-features", element: <PremiumFeatures /> },
    { path: "/live-testing", element: <LiveTesting /> },

    { path: "/code-overview", element: <CodeOverview /> },
    { path: "/code-audit", element: <CodeAudit /> },
    { path: "/code-specification", element: <CodeSpecification /> },
    { path: "/business-requirements", element: <BusinessRequirements /> },
    { path: "/code-documentation", element: <CodeDocumentation /> },
    { path: "/unit-test", element: <UnitTest /> },
    { path: "/data-generation", element: <DataGeneration /> },
    { path: "/code-impact-analysis", element: <CodeImpactAnalysis /> },
    { path: "/code-refactoring", element: <CodeRefactoring /> },
    { path: "/version-based-conversion", element: <VersionBasedConversion /> },
    { path: "/target-architecture-based-conversion", element: <TargetArchitectureBasedConversion /> },
    { path: "/ETL-mapping", element: <ETLMapping /> },
    
    { path: "/feedback", element: <Feedback /> },
    { path: "/case-scenarios", element: <CaseScenarios /> },
    { path: "/architecture-based-conversion", element: <ArchitectureConversion /> },
    { path: "/security-validator", element: <SecurityValidator /> },
    { path: "/settings/user-list", element: <UserList /> },
    { path: "/pricing-details", element: <PricingDetails /> },
    { path: "/faq", element: <FAQPage /> },
    { path: "/profile", element: <Profile /> },
    { path: "/conversion-history", element: <ConversionHistory /> },
    { path: "/conversion-details/:filename", element: <ConversionDetails /> },
  ];

  // Route element rendering based on login status
  const renderRoute = ({ path, element, isPublic }) => (
    <Route
      key={path}
      path={path}
      element={isPublic || isLoggedIn ? element : <Navigate to="/login" />}
    />
  );

  return (
    <>
      {apiCount > 0 && (
        <>
          <Offcanvas show backdrop="static" />
          <Spinner className="overlay-box" animation="border" variant="primary" />
          <div className="loading-message">{loadingMessage}</div>
        </>
      )}
      <div className="wrapper">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <div className="content-wrapper">
          {location.pathname !== "/login" && <Header />}
          <div
            className={`main-content ${
              ["/login", "/register", "/forgotPassword"].includes(location.pathname)
                ? "pt-0 pb-0"
                : ""
            }`}
          >
            <Routes>{routes.map(renderRoute)}</Routes>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppRoute;
